export default __webpack_public_path__ + "static/media/Boton_4.4035a6e5.webp";